export const privacyPolicyUrl = 'https://www.seaters.ai/privacy';
export const userAgreementUrl = 'https://www.seaters.ai/user-agreement';
